export class NumberConstants {
  public static readonly DECIMAL_AMOUNT = 4;
}
